import { render, staticRenderFns } from "./AdminOrderHistoryTableHeader.vue?vue&type=template&id=e6f68d36&"
import script from "./AdminOrderHistoryTableHeader.vue?vue&type=script&lang=js&"
export * from "./AdminOrderHistoryTableHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports